module.exports = __webpack_public_path__ + "img/zi.45f7051d.png";